export enum ExportGrouping {
    BY_TASK             = 'byTask',
    BY_USER             = 'byUser',
    BY_TASK_AND_USER    = 'byTaskAndUser',
    BY_DATE             = 'byDate',
    BY_TIME_REPORTS     = 'timeReports'
}